import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcBookingTable from '@bookings/components/tables/booking-table/booking-table.vue';

@Component({
  name: 'bpc-booking',
  components: {
    'bpc-booking-table': BpcBookingTable,
  },
})
export default class Booking extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
